import { useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import { blogPosts } from "../../data/blogPosts";
import SEO from "../../seo/SEO";
import AffiliateCTA from "../../components/affiliate/AffiliateCTA";
import ComparisonTable from "../../components/affiliate/ComparisonTable";
import AffiliateDisclosureInline from "../../components/legal/AffiliateDisclosureInline";

export default function BlogPost() {
  const { slug } = useParams();

  const post = useMemo(
    () => blogPosts.find((p) => p.slug === slug),
    [slug]
  );

  if (!post) {
    return (
      <div className="container">
        <h1>Post not found</h1>
        <Link to="/blog">← Back to Blog</Link>
      </div>
    );
  }

  const canonicalUrl = `${window.location.origin}/blog/${post.slug}`;

  return (
    <div className="container">
      {/* SEO / Discover / Social */}
      <SEO
        title={post.title}
        description={post.metaDescription}
        canonical={canonicalUrl}
        image={post.heroImage}
        type="article"
        publishedTime={post.publishedAt}
        modifiedTime={post.updatedAt}
      />

      <article className="post">
        {/* Header */}
        <header className="post__header">
          <h1>{post.title}</h1>

          <p className="post__meta">
            {new Date(post.publishedAt).toLocaleDateString()} ·{" "}
            {post.category} · by {post.author}
          </p>

          {post.heroImage && (
            <img
              src={post.heroImage}
              alt={post.heroImageAlt}
              className="post__hero"
            />
          )}
        </header>

        {/* Affiliate Disclosure (required) */}
        <AffiliateDisclosureInline />

        {/* Article Content */}
        <div className="post__content">
          {post.content.map((block, idx) => {
            /* Headings */
            if (block.type === "h2") return <h2 key={idx}>{block.text}</h2>;
            if (block.type === "h3") return <h3 key={idx}>{block.text}</h3>;

            /* Paragraphs */
            if (block.type === "p") return <p key={idx}>{block.text}</p>;

            /* Lists */
            if (block.type === "ul") {
              return (
                <ul key={idx}>
                  {block.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              );
            }

            /* Comparison Table */
            if (block.type === "comparison") {
              return <ComparisonTable key={idx} post={post} />;
            }

            /* Affiliate CTA (FIXED + DYNAMIC) */
            if (block.type === "cta") {
              const href = post.affiliate?.[block.tool];

              if (!href) return null;

              return (
                <AffiliateCTA
                  key={idx}
                  href={href}
                  tool={block.tool}
                  slug={post.slug}
                >
                  {block.label}
                </AffiliateCTA>
              );
            }

            return null;
          })}
        </div>
      </article>
    </div>
  );
}